import { render, staticRenderFns } from "./ripple.vue?vue&type=template&id=2c58b19c&scoped=true&"
import script from "./ripple.vue?vue&type=script&lang=js&"
export * from "./ripple.vue?vue&type=script&lang=js&"
import style0 from "./ripple.vue?vue&type=style&index=0&id=2c58b19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58b19c",
  null
  
)

export default component.exports